<template>
  <div class="products">
    <v-row>
      <v-col cols="12">
        <v-layout row class="flex-container">
          <v-flex xs6 sm4 md3 v-for="(set, index) in set1" :key="index">
            <v-card max-width="300" router :to="set.router">
              <div>
                <v-img height="200" :src="set.img"></v-img>
                <v-card-title
                  class="subtitle-1 pb-0 font-weight-medium"
                  v-text="set.title"
                ></v-card-title>

                <v-card-text>
                  <div class="subtitle-1">{{ set.price }}</div>
                  <v-row align="center" class="mx-0">
                    <v-rating
                      :value="set.rating"
                      color="red"
                      dense
                      half-increments
                      readonly
                      size="14"
                    ></v-rating>

                    <div class="grey--text ml-4">{{ set.rating }}</div>
                  </v-row>
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      set1: [
        {
          title: 'Caps',
          router: '/caps',
          img: '/img/products/img10.jpg',
          price: 'R 159.99',
          rating: '4.5',
        },
        {
          title: 'Golf T-shirts',
          router: '/',
          img: '/img/products/img11.jpg',
          price: 'R 299.99',
          rating: '3.0',
        },
        {
          title: 'Shorts',
          router: '/shorts',
          img: '/img/products/img12.jpg',
          price: 'R 250.00',
          rating: '5.0',
        },
        {
          title: 'Hats',
          router: '/',
          img: '/img/products/img13.jpg',
          price: 'R 150.00',
          rating: '4.0',
        },
        {
          title: 'Shorts',
          router: '/shorts',
          img: '/img/products/img15.jpg',
          price: 'R 250.00',
          rating: '4.5',
        },
        {
          title: 'Hats',
          router: '/',
          img: '/img/products/img16.jpg',
          price: 'R 200.00',
          rating: '3.0',
        },
        {
          title: 'T-shirts',
          router: '/',
          img: '/img/products/img17.jpg',
          price: 'R 250.00',
          rating: '5.0',
        },
        {
          title: 'Golf T-shirts',
          router: '/',
          img: '/img/products/img18.jpg',
          price: 'R 299.99',
          rating: '4.0',
        },
      ],
    }
  },
}
</script>
